module.exports = __webpack_public_path__ + "img/tr.ed12415c.svg";